<template>
    <div class="collectionPage bg-fff">
        <div class="top">
            <img src="../../../images/user/collection.jpg" alt="">
        </div>
        <div class="main">
            <div class="collectionDetail">
                <!--<p>如何使用采集工具</p>-->
                <!--<div class="detailCollect">-->
                    <!--<img src="../../../images/collection/1200_01.jpg" alt="">-->
                    <!--<img src="../../../images/collection/1200_02.jpg" alt="">-->
                    <!--<img src="../../../images/collection/1200_03.jpg" alt="">-->
                    <!--&lt;!&ndash;<img src="../../../images/collection/04.jpg" alt="">-->
                    <!--<img src="../../../images/collection/05.jpg" alt="">&ndash;&gt;-->
                <!--</div>-->

                <div class="detailCollect">
                    <img src="../../../images/collection/111_01.jpg" alt="">
                </div>

            </div>
            <div class="collectionButton">
                <p>安装住逻辑采集工具</p>
                <div class="detailCollect">
                    <div class="buttonCon">
                        <div class="testDetail">拖拽此按钮到浏览器书签栏</div>
                        <a  href="javascript:(function(a,b,c,d){a[c]?a[c].show():(d=b.createElement('script'),d.id='zhulogic_widgets',d.setAttribute('charset','utf-8'),
    d.src='https://b.zhulogic.com/collect/index.js',b.body.appendChild(d))})(window,document,'ZHULOGIC__GLOBAL');" onclick="return false;" class="mask-button">
                            <div class="button-collection">斑斓采集工具</div>
                        </a>
                    </div>
                </div>
            </div>

            <div class="imageDetail" style="margin-top: 45px;">
                <p>安装方法</p>
                <div class="detailCollect">
                    <ul>
                        <li :class="active==='google' ? 'activeLi' : ''" @click="changeActive('google')"><i :class="active==='google' ? 'activei' : ''" class="iconfont icon-google"></i>谷歌浏览器</li>
                        <li :class="active==='test' ? 'activeLi' : ''" @click="changeActive('test')"><i :class="active==='test' ? 'activei' : ''" class="iconfont icon-icon-test"></i>360浏览器</li>
                        <li :class="active==='firefox' ? 'activeLi' : ''" @click="changeActive('firefox')"><i :class="active==='firefox' ? 'activei' : ''" class="iconfont icon-firefox"></i>火狐浏览器</li>
                        <!--<li :class="active==='ie' ? 'activeLi' : ''" @click="changeActive('ie')"><i :class="active==='ie' ? 'activei' : ''" class="iconfont icon-ie"></i>IE浏览器</li>-->
                        <li :class="active==='safari' ? 'activeLi' : ''" @click="changeActive('safari')"><i :class="active==='safari' ? 'activei' : ''" class="iconfont icon-safari"></i>Safari</li>
                    </ul>
                    <div class="clr"></div>
                    <div class="imhgShow">
                        <img v-if="active === 'google'" src="../../../images/collection/guge.jpg" alt="">
                        <img v-if="active === 'test'" src="../../../images/collection/360.jpg" alt="">
                        <img v-if="active === 'firefox'" src="../../../images/collection/huohu.jpg" alt="">
                        <!--<img v-if="active === 'ie'" src="../../../images/user/browser.jpg" alt="">-->
                        <img v-if="active === 'safari'" src="../../../images/collection/safari.jpg" alt="">
                    </div>
                </div>
            </div>

            <div class="collectionDetail">
                <div class="detailCollect">
                    <img src="../../../images/collection/222_03.jpg" alt="">
                </div>

            </div>

            <div class="collectionDetail">
                <div class="detailCollect">
                    <img src="../../../images/collection/333_04.jpg" alt="">
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                active: 'google'
            }
        },
        methods:{
            changeActive(text){
                this.active = text;
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .collectionPage{
        .top{
            width: 100%;
            margin-bottom: 44px;
            img{
                width: 100%;
            }
        }
        .main{
            margin: 0 auto;
            width: 1200px;
            .collectionDetail, .collectionButton, .imageDetail{
                width: 100%;
                /*margin-bottom: 40px;*/
                p {
                    font-size: 23px;
                    color: #353838;
                    opacity: 0.79;
                    font-weight: bold;
                    margin-bottom: 16px;
                }
                .detailCollect{
                    /*height: 443px;*/
                    width: 100%;
                    background: #D8D8D8;
                }
            }
            .collectionDetail .detailCollect{
                height: auto;
                background: #fff;
                img{
                    width: 100%;
                }
            }
            .collectionButton{
                width: 890px;
                margin: 0 auto;
                .detailCollect{
                    height:222px;
                    text-align: center;
                    line-height: 290px;
                    width: 100%;
                    background: #EBEFF0;
                    .buttonCon{
                        display: inline-block;
                        width: 494px;
                        height: 80px;
                        position: relative;
                        a{
                            display: inline-block;
                            background: transparent;
                            width: 494px;
                            height: 80px;
                            position: absolute;
                            left: 0;
                            top:0;
                        }
                        .button-collection{
                            width: 100%;
                            height: 100%;
                            line-height: 80px;
                            opacity: 0;
                            cursor:move;
                            position: absolute;
                            left: 0;
                            top:0;
                            z-index: 2;
                        }
                        .testDetail{
                            width: 100%;
                            height: 100%;
                            line-height: 80px;
                            text-align: center;
                            background: #99C72C;
                            box-shadow: 0 2px 10px 0 #99C72C;
                            border-radius: 4px;
                            font-size: 36px;
                            cursor:move;
                            color: #FFFFFF;
                            position: absolute;
                            z-index: 0;
                            left: 0;
                            top:0;
                        }
                    }
                }
            }

            .imageDetail{
                width: 890px;
                margin: 0 auto;
                .detailCollect{
                    background: #fff;
                    height: auto;
                    ul{
                        width: 100%;
                        li{
                            width: 25%;
                            float: left;
                            height: 58px;
                            font-size: 20px;
                            color: #6C6F70;
                            line-height: 58px;
                            text-align: center;
                            cursor: pointer;
                            background: #EBEFF0;
                            border: 1px solid #DCE0E0;
                            margin-bottom: 40px;
                            i{
                                font-size: 20px;
                                color: #6C6F70;
                                margin-right: 3px;
                            }
                            .activei{
                                color: #353838;
                            }
                            &:hover{
                                color: #353838;
                            }
                            &:hover i{
                                color: #353838;
                            }
                        }
                        .activeLi{
                            color: #353838;
                            background: #fff;
                            border:none;
                        }
                    }
                    .imhgShow{
                        width: 100%;
                        height: 465px;
                        overflow: hidden;
                        padding: 0 5%;
                        img{
                            width: 100%;
                        }
                    }
                }
            }
        }
        .bottom{
            background: #F2F4F5;
        }
    }
</style>